import { apiFetch } from '../../api/api';

export function printStatus(entry) {
  if (entry.executionConflict || entry.latestExecutionStatus === 'outcome_unknown') return 'Outcome uncertain';
  if (entry.latestExecutionStatus === 'failed') return 'Printer error';
  if (entry.latestExecutionStatus === 'submitted') return 'Sent to printer';
  if (entry.dispatchState === 'dispatch_error') return 'Request accepted; delivery needs attention. Do not retry.';
  return 'Queued';
}
export function admissionMessage(result) {
  if (result?.admitted === true) return printStatus(result);
  if (result?.admitted === false) return 'Request not accepted.';
  return 'Print request status is uncertain. Check print history before trying again.';
}
// Attempt a POST once; preserve admitted error identity without replaying it.
export async function requestPrint(path, body) {
  try { return await apiFetch(path, { method: 'POST', body, retryAuth: false }); }
  catch (error) { return error?.response?.data || { admitted: null }; }
}
export async function printSelectedRecords(recordIds, datasetId) {
  const ids = [...new Set(recordIds.map(id => String(id).toLowerCase()))];
  if (!ids.length) return [];
  const response = await requestPrint('/datadoc/printSelected', { recordIds: ids, datasetId });
  return ids.map(dataDocId => {
    const row = response?.results?.find(r => String(r.dataDocId).toLowerCase() === dataDocId);
    return { dataDocId, ...(row ? (row.result || row) : { admitted: response?.admitted === false ? false : null }) };
  });
}
